import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';
import {Body} from 'shells/typography/body';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function ConnectedFormsInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.CONNECTED_FORMS_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={
                <img src='/include/images/onboarding/connected-forms.svg' alt='Connected forms' />
            }
            title='What are connected forms?'
            body={
                <>
                    <Body>
                        Collect leads from any form on your website by setting up Nutshell Analytics
                        to capture submissions from forms created with other tools
                    </Body>
                    <p>
                        <BulletedList
                            bullets={[
                                <span key='bullet-1'>
                                    Set up tracking by embedding a small snippet of code on your
                                    website (if it’s built with WordPress, you can try our plugin)
                                </span>,
                                <span key='bullet-2'>
                                    Wait for submissions to the forms on your site that weren’t
                                    created with Nutshell – they’ll appear here when detected
                                </span>,
                                <span key='bullet-3'>
                                    Decide which fields will save submission data to people,
                                    companies, and leads
                                </span>,
                            ]}
                        />
                    </p>
                </>
            }
            learnEvenMoreHref='https://www.nutshell.com/features/forms'
        />
    );
}
